/**
 * This enum represents various route paths used in the application.
 */
export enum RoutesValues {
  NOT_FOUND = 'not-found',
  DASHBOARD = 'dashboard',
  HOME = 'home',
  AUTH = 'auth',
  LOGIN = 'login',
  TEMPLATES = 'templates',
  DOCUMENT_REQUESTS = 'document-requests',
  FORM = 'form',
  DETAILS = 'details',
  FOLDERS = 'folders',
  CREATE = 'create',
  MODELS = 'models',
  FORBIDDEN = 'forbidden',
  EDIT_TEMPLATE = 'edit-template',
  SETTINGS = 'settings',
  CONTRACTS = 'contracts',
  COUNTRY_CONFIG = 'country-config',
  FILES = 'files',
  VIEW = 'view',
  FILL = 'fill',
  ASSIGN = 'assign',
  EDIT = 'edit',
  NEW_MODEL = 'new-model',
  NEW = 'new',
  EMPLOYEES = 'employees',
  PROFILE = 'profile',
  CONTRACT_VIEW = 'contract-view',
  GUESTS = 'guests',
  SIGN = 'sign',
  COMPLIANCES = 'compliances',
  COMPLIANCES_LIST_DOC = 'compliances/list-documents',
  PAYSLIPS = 'payslips',
}
